// src/context/AuthContext.js
import { createContext, useContext, useEffect, useState } from 'react';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from '../firebase';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const logout = () => signOut(auth);

  // Only your 10 users can see the Fantasy area
  const allowedEmails = [
    'levibaldridge@gmail.com', 'keeganbaldridge@yahoo.com',
    'd_weber27@yahoo.com', 'bryan.rask2@gmail.com',
    'gpete50uh@yahoo.com', 'justinhabiger@yahoo.com',
    'e.borchard@aol.com', 'wyattfiecke@gmail.com',
    'tonyfrank03@yahoo.com', 'maussam33@yahoo.com'
  ];

  const isFantasyUser = !!user && allowedEmails.includes(user.email);

  // ✅ Make EVERY league user an admin
  const isAdmin = isFantasyUser;               // <— key line

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setLoading(false);
    });
    return () => unsub();
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, isFantasyUser, isAdmin, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
